import React from 'react';

import { Box, Button, Group } from '@mantine/core';

interface PreviewModalFooterProps {
  onClose: () => void;
  onEdit: () => void;
  showEditButton: boolean;
}

const PreviewModalFooter = ({ onClose, onEdit, showEditButton }: PreviewModalFooterProps): JSX.Element => (
  <Box
    p='lg'
    pt='md'
    sx={theme => ({
      flexShrink: 0,
      borderTop: `1px solid ${theme.colors.gray[3]}`,
    })}
  >
    <Group position='right'>
      <Button variant='subtle' onClick={onClose}>
        Close
      </Button>
      {showEditButton && <Button onClick={onEdit}>Edit Template</Button>}
    </Group>
  </Box>
);

export default PreviewModalFooter;
